module.exports = __webpack_public_path__ + "afdee8c2eb4a240a1e9672c1de59913e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/P28 - TempleApproach - Orbital bombardment II copy.jpg
// module id = 154
// module chunks = 0